module.exports = __webpack_public_path__ + "static/media/icon-rooms.d8dd5001.svg";